(function () {
  if (window.__evgeStickyAtc) return;
  window.__evgeStickyAtc = true;

  function initBar(bar) {
    var targetId = bar.getAttribute('data-target-id');
    var target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;

    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var visible = false;
    var hideTimeout = null;

    function show() {
      if (visible || !mobileQuery.matches) return;
      visible = true;
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }
      bar.hidden = false;
      // Force a reflow so the removal of [hidden] and the transform
      // transition don't collapse into a single, un-animated paint.
      void bar.offsetHeight;
      bar.classList.add('sticky-atc--visible');
    }

    function hide() {
      if (!visible) {
        bar.hidden = true;
        return;
      }
      visible = false;
      bar.classList.remove('sticky-atc--visible');
      var duration = reducedMotionQuery.matches ? 0 : 300;
      hideTimeout = setTimeout(function () {
        bar.hidden = true;
        hideTimeout = null;
      }, duration);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!mobileQuery.matches) {
            hide();
          } else if (entry.isIntersecting) {
            hide();
          } else {
            show();
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(target);

    function onViewportChange(event) {
      if (!event.matches) hide();
    }

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', onViewportChange);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(onViewportChange);
    }
  }

  function init() {
    var bars = document.querySelectorAll('[data-sticky-atc]');
    bars.forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
